exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".other-news{width:100%;margin-bottom:2rem;position:relative}.news-button-container{display:flex;padding:2rem 1rem;width:100%}.news-button{background-color:#577f40;box-shadow:1px 1px 2px 2px rgba(0,0,0,.3);color:#fff;width:100%;padding:1rem .5rem;font-size:1.5rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-53662269","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/news/other-news.vue
// module id = 133
// module chunks = 4